import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { Spinner } from 'react-bootstrap'

import { SingleCampaignPage } from './single-campaign-page'
import { CampaignRouterPageV2 } from './campaign-router-page-v2'

export function CampaignRouterPage() {
  const featureFlags = useFeatureFlagService()

  if (featureFlags.isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner animation="border" />
      </div>
    )
  }

  if (!featureFlags.enableEmailSequencing) {
    return <SingleCampaignPage />
  }

  return <CampaignRouterPageV2 />
}
